import api, { ValidateAxiosError } from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';
import { SearchDto } from '@/shared/types/search.dto';
import type { CreateProcessoSeletivoDto } from '@/api.types';
import type {
  CreateVagaDto as ApiCreateVagaApiDto,
  ReadCursoDto as ApiReadCursoDto,
  ReadVagaDto as ApiReadVagaDto,
  ReadProcessoSeletivoDto as ApiReadProcessoSeletivoDto,
} from '@/api.types';

export type CreateVagaApiDto = ApiCreateVagaApiDto;
export type ReadCursoDto = ApiReadCursoDto;
export type ReadVagaDto = ApiReadVagaDto;
export type ReadProcessoSeletivoDto = ApiReadProcessoSeletivoDto;

export interface CreateVagaDto {
  cursoId: number;
  municipios: string[];
}

export type UpdateProcessoSeletivoDto = Partial<CreateProcessoSeletivoDto>;

export interface CreateProcessoSeletivoResponseDto {
  id: number;
  emailsNotificacaoEnviados: boolean;
}

export class ProcessoSeletivoService {
  async create(obj: CreateProcessoSeletivoDto): Promise<CreateProcessoSeletivoResponseDto> {
    try {
      return (await api.post(Endpoints.PROCESSO_SELETIVO, obj)).data;
    } catch (error) {
      return ValidateAxiosError(error, 'Falha ao cadastrar processo seletivo.');
    }
  }

  async findOne(id: number): Promise<ReadProcessoSeletivoDto> {
    try {
      const response = await api.get(Endpoints.PROCESSO_SELETIVO + '/' + id);
      return response.data;
    } catch (error) {
      return ValidateAxiosError(error, 'Falha ao buscar o processo seletivo.');
    }
  }

  async findOnePublic(id: number): Promise<ReadProcessoSeletivoDto> {
    try {
      const response = await api.get(Endpoints.PROCESSO_SELETIVO + '/public/' + id);
      return response.data;
    } catch (error) {
      return ValidateAxiosError(error, 'Falha ao buscar o processo seletivo.');
    }
  }

  async findOnePublicNome(id: number): Promise<{ id: number; nome: string }> {
    try {
      const response = await api.get(Endpoints.PROCESSO_SELETIVO + '/public/' + id + '/nome');
      return response.data;
    } catch (error) {
      return ValidateAxiosError(error, 'Falha ao buscar o processo seletivo.');
    }
  }

  async update(id: number, dto: UpdateProcessoSeletivoDto): Promise<void> {
    try {
      return (await api.put(Endpoints.PROCESSO_SELETIVO + '/' + id, dto)).data;
    } catch (error) {
      return ValidateAxiosError(error, 'Falha ao atualizar processo seletivo.');
    }
  }

  async uploadProva(id: number, file: File): Promise<void> {
    try {
      const formData = new FormData();
      formData.append('file', file);

      await api.post(`${Endpoints.PROCESSO_SELETIVO}/${id}/upload-prova`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    } catch (error) {
      throw ValidateAxiosError(error, 'Falha ao enviar a prova do processo seletivo.');
    }
  }

  async remove(id: number): Promise<void> {
    try {
      await api.delete(Endpoints.PROCESSO_SELETIVO + '/' + id);
    } catch (error) {
      throw ValidateAxiosError(error, 'Falha ao remover processo seletivo.');
    }
  }

  async findAll(conditions: SearchDto): Promise<[ReadProcessoSeletivoDto[], number]> {
    try {
      const response = await api.get(Endpoints.PROCESSO_SELETIVO, {
        params: { skip: conditions.skip, take: conditions.take },
      });
      return response.data;
    } catch (error) {
      return ValidateAxiosError(error, 'Falha ao listar processos seletivos.');
    }
  }
}

